/** New password, typed twice. The length rule matches the API's (app/accounts.py). */

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const MIN_PASSWORD = 10;

export function passwordProblem(password: string, again: string): string | null {
  if (password.length < MIN_PASSWORD) return `use at least ${MIN_PASSWORD} characters`;
  if (password !== again) return "the two passwords don't match";
  return null;
}

export function PasswordFields(props: {
  password: string;
  again: string;
  onPassword: (value: string) => void;
  onAgain: (value: string) => void;
}) {
  return (
    <>
      <div className="space-y-1.5">
        <Label htmlFor="new-password">New password</Label>
        <Input id="new-password" type="password" autoComplete="new-password" required minLength={MIN_PASSWORD}
               value={props.password} onChange={(e) => props.onPassword(e.target.value)} />
        <p className="text-xs text-muted-foreground">At least {MIN_PASSWORD} characters.</p>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="new-password-again">Type it again</Label>
        <Input id="new-password-again" type="password" autoComplete="new-password" required
               value={props.again} onChange={(e) => props.onAgain(e.target.value)} />
      </div>
    </>
  );
}
